import { takeLatest, call, put, all } from 'redux-saga/effects'

import { request } from '../../utils/request'
import { BASE_PATH, LANG } from '../App/constants'
import { loadSuccess, loadError } from './actions'
import { CONTENT_LOAD } from './constants'
import { winsSchema } from './validator'

export function* getWins() {
  const url = `${BASE_PATH}/${LANG}/last-wins`
  try {
    const response = yield call(request, url, {
      headers: {
        accept: 'application/json',
      },
    })

    yield winsSchema.validateSync(response.data)
    yield put(loadSuccess(response.data))
  } catch (error) {
    yield put(loadError(error))
  }
}

export function* watchWinsLoad() {
  yield takeLatest(CONTENT_LOAD, getWins)
}

export default function* rootSagas() {
  yield all([watchWinsLoad()])
}
